import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../../config/constants";
import axios from "axios";

const initialState = {
  isSplashLoading: true,
  isLoading: false,
  isLoggedIn: false,
  user: {
    id: '',
    name: '',
    email: ''
  },
  status: 'idle'
};

export const checkAuthentication = createAsyncThunk('general/checkAuthentication', async ()=>{
  const response = await axios.post(`${API_URL}/auth`, {
    callback: 'status'
  }, {
    withCredentials: true  // Allows cross-origin cookies if server allows
  });
  return response.data;
})

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    showSplashLoading: state => {
      state.isSplashLoading = true;
    },
    hideSplashLoading: state => {
      state.isSplashLoading = false;
    },
    showLoading: state => {
      state.isLoading = true;
    },
    hideLoading: state => {
      state.isLoading = false;
    },
    logIn: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;
    },
    logOut: state => {
      state.isLoggedIn = false;
      state.user = {
        id: '',
        name: '',
        email: ''
      }
    },
    setUserData: (state, action) => {
      state.user = action.payload;
    }
  },
  extraReducers(builder){
    builder
      .addCase(checkAuthentication.pending, (state, action)=> {
        state.status = 'idle';
      })
      .addCase(checkAuthentication.fulfilled, (state, action)=> {
        state.status = 'succeeded';
        state.isSplashLoading = false;
        state.isLoggedIn = true;
        state.user = action.payload.user;
      })
      .addCase(checkAuthentication.rejected, (state, action)=> {
        state.status = 'failed';
        state.isSplashLoading = false;
      })
  }
});

export const userData = state => state.general.user;
export const userStatus = state => state.general.status;
export const splashLoadingStatus = state => state.general.isSplashLoading;
export const loadingStatus = state => state.general.isLoading;
export const loggedInStatus = state => state.general.isLoggedIn;
export const {showSplashLoading, hideSplashLoading, showLoading, hideLoading, logIn, logOut, setUserData} = generalSlice.actions;
export default generalSlice.reducer;

